import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import GetSystemProgramGql from '../queries/GetSystemProgram.graphql';
import type { GetSystemProgramQuery, GetSystemProgramQueryVariables } from '../queries/__generated__/GetSystemProgram';

type SystemProgram = NonNullable<GetSystemProgramQuery['EnterpriseProgram']>['getSystemProgram'];

export type UseSystemProgramResult = {
  systemProgram: SystemProgram;
  loading: boolean;
  error?: ApolloError;
};

export function useSystemProgram(organizationId: string | null | undefined): UseSystemProgramResult {
  const { data, loading, error } = useQuery<GetSystemProgramQuery, GetSystemProgramQueryVariables>(
    GetSystemProgramGql,
    {
      variables: { organizationId: organizationId ?? '' },
      skip: !organizationId,
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
    }
  );

  return {
    systemProgram: data?.EnterpriseProgram?.getSystemProgram,
    loading,
    error,
  };
}
